<!-- <main>
    <section>
        <div class="container-fluid">

            <app-navbar-dos></app-navbar-dos>

        </div>
    </section>
</main> -->




<div class="container">
    <br />
    <div class="row g-0">
        <div class="col-lg-2">
            <img src="assets/images/logo.png" class="img-thumbnail" alt="LogoCamaraDiptuados" />
        </div>
        <div class="col-lg-10">
            <br />

            <h2 style="text-align: center">
                Resultados
            </h2>
        </div>
    </div>
    <br />
    <div class="row">
        <div class="table-responsive">
            <div class="col-12 text-center" *ngIf="termino">
                <h2>Buscando "{{termino}}"</h2>
                <span *ngIf="loading; else loadingFiles ">
                    <span class="loader">

                    </span>
                    <br>
                    Cargando...

                </span>

                <ng-template #loadingFiles></ng-template>
                <hr>
                <div class="text-end col-12">
                    Se ha{{contendientes.length==1?"":"n"}} encontrado {{contendientes.length}}
                    registro{{contendientes.length==1?"":"s"}}
                </div>
            </div>

            <table class="table">
                <thead class="table green">
                    <tr>
                        <th class="enc_centrado" scope="col">N°</th>
                        <th class="enc_centrado" scope="col">Diputada / Diputado</th>
                        <th class="enc_centrado" scope="col">Grupo Parlamentario</th>
                        <th class="enc_centrado" scope="col">Entidad federativa</th>
                        <th class="enc_centrado" scope="col">Distrito / Circunscripción</th>
                        <th class="enc_centrado" scope="col">Tipo de elección</th>
                        <th class="enc_centrado" scope="col">Fecha de recepción</th>
                        <th class="enc_centrado" scope="col">En funciones</th>
                        <th class="enc_centrado" scope="col">Reelecciones Previas</th>
                        <!-- <th class="enc_centrado" scope="col">Folio</th> -->
                        <th class="enc_centrado" scope="col">Documento</th>
                    </tr>
                </thead>
                <tbody *ngFor="let c of contendientes">
                    <tr>
                        <td>{{ c.Numero }}</td>
                        <td>{{ c.NombreDiputado }}</td>
                        <td>{{ c.GrupoParlamentario }}</td>
                        <td>{{ c.EntidadFederativa }}</td>
                        <td>{{ c.DistritoCircuns }}</td>
                        <td>{{ c.TipoEleccion }}</td>
                        <td>{{ c.FechaRecepcion | date: "dd 'de' MMMM 'del' yyyy" :'UTC'}}</td>
                        <td>{{ c.EnFunciones }}</td>
                        <td><span *ngIf="c.ReeleccionPrevia == 1">{{ c.ReeleccionesLegilatura }}</span> </td>
                        <!-- <td>{{ c.Folio }}</td> -->
                        <td style="text-align: center;">
                            <button type="button" class="btn btn-success" *ngIf="c.Enlace !== 0; else noFiles"
                                (click)="downloadBase64File(c)">
                                <i class="fas fa-file-download"></i>
                            </button>
                            <!-- <button type="button" class="btn btn-primary" *ngIf="c.Enlace !== 0; else noFiles"
                                (click)="VerCarta(c.Oid)">
                                Ver
                            </button> -->
                            <ng-template #noFiles>
                        <td></td>
                        </ng-template>
                        </td>
                    </tr>
                    <tr *ngIf="c.Notas !== null && c.Notas">
                        <td colspan="12">
                            <table class="table">
                                <thead class="table-light">
                                    <tr>
                                        <td><b> Notas:</b> {{ c.Notas }}</td>
                                    </tr>
                                </thead>
                                <!-- <tbody>
                              <tr>
                                  <td></td>
                              </tr>
                          </tbody> -->
                            </table>
                        </td>
                    </tr>
                </tbody>

            </table>


        </div>
    </div>
</div>